module.exports = __webpack_public_path__ + "static/media/search.cfcec6b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.svg
// module id = 882
// module chunks = 0